'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TunnelType = exports.defaultTunnel = exports.default = undefined;

var _dataProvider = require('./dataProvider');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dataProvider).default;
  }
});
Object.defineProperty(exports, 'defaultTunnel', {
  enumerable: true,
  get: function get() {
    return _dataProvider.defaultTunnel;
  }
});
Object.defineProperty(exports, 'TunnelType', {
  enumerable: true,
  get: function get() {
    return _dataProvider.TunnelType;
  }
});

require('isomorphic-fetch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/data-provider/index.js
// module id = 48
// module chunks = 0